<template>
  <div>
    <div class="q-mt-md">
      <div class="row-reverse">
        <q-btn
          color="primary"
          label="Add Field"
          @click="onAdd"
          class="q-mb-md q-ml-lg"
        />
      </div>
    </div>
    <BaseTable
      :rows="formattedFields"
      :columns="columns"
      :total-rows="totalFields"
      :get-edit-url="getEditUrl"
    >
      <template #actions="{ row }">
        <q-td class="q-pa-none text-center">
          <q-btn
            size="sm"
            color="primary"
            label="Edit"
            @click="$router.push(getEditUrl(row))"
            class="q-mr-sm"
          />
          <q-btn
            size="sm"
            :color="row.is_active ? 'negative' : 'positive'"
            :label="row.is_active ? 'Deactivate' : 'Reactivate'"
            @click="toggleActive(row)"
          />
        </q-td>
      </template>
    </BaseTable>
  </div>
</template>

<script>
import BaseTable from '@/components/BaseTable';
import axios from 'axios';

export default {
  name: 'FieldTable',
  components: {
    BaseTable
  },
  data() {
    return {
      fields: [],
      totalFields: 0,
      columns: [
        { name: 'id', align: 'left', label: 'ID', field: 'id', sortable: true },
        { name: 'name', align: 'left', label: 'Name', field: 'name', sortable: true },
        { name: 'description', align: 'left', label: 'Description', field: 'description', sortable: false },
        { name: 'producer_name', align: 'left', label: 'Producer', field: 'producer_name', sortable: true },
        { name: 'add_date', align: 'left', label: 'Add Date', field: 'add_date', sortable: true },
        { name: 'edit_date', align: 'left', label: 'Edit Date', field: 'edit_date', sortable: true },
        { name: 'actions', align: 'center', label: 'Actions', field: 'actions', sortable: false }
      ]
    };
  },
  computed: {
    formattedFields() {
      return this.fields.map(field => ({
        ...field,
        producer_name: field.producer_id.name, // Assuming the API returns nested producer object with `name`
        add_date: new Date(field.add_date).toLocaleDateString(),
        edit_date: new Date(field.edit_date).toLocaleDateString()
      }));
    }
  },
  created() {
    this.fetchFields();
  },
  methods: {
    fetchFields() {
      axios
        .get('/api/v1/field/fields/', { params: { show_inactive: true } })
        .then(response => {
          this.fields = response.data;
          console.log(response.data);
          this.totalFields = response.data.length;
        })
        .catch(error => {
          console.error('Error fetching fields:', error);
        });
    },
    onAdd() {
      this.$router.push('/field/add');
    },
    getEditUrl(row) {
      return `/field/edit/${row.id}/`;
    },
    toggleActive(row) {
      axios
        .patch(`/api/v1/field/fields/${row.id}/`, { is_active: !row.is_active })
        .then(() => {
          this.$q.notify({
            color: 'green',
            message: `Field ${row.is_active ? 'deactivated' : 'reactivated'}.`,
            icon: 'check'
          });
          this.fetchFields();
        })
        .catch(error => {
          console.error('Error updating field active state:', error);
          this.$q.notify({
            color: 'red',
            message: 'Failed to update field status.',
            icon: 'error'
          });
        });
    }
  },
  watch: {
    fields() {
      this.$forceUpdate();
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for the FieldTable here */
</style>
